import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../users.service';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})

/**
 * Utility user component
 */
export class userComponent implements OnInit {
  // bread crumb items
  loading = false;
  listBanks: any;
  private fb = inject(FormBuilder);
  userForm: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required]],
    //role: ['4'],
    password: ['', [Validators.required]],
    passwordConfirmation: ['', [Validators.required]],
    //validRole: [0],
    companyId: [0],
    documentType: ['', [Validators.required]],
    documentNumber: ['', [Validators.required, Validators.minLength(6)]],
    cellPhone: ['', [Validators.required]],
    accountType: [''],
    accountNumber: ['', [Validators.required]],
    partnerType: [''],
    bankId: [0, [Validators.required]],
    funderStatus: [null],
    storeStatus: [false],
    userType: ['', [Validators.required]],
  });

  constructor(
    private serviceListBank: UsersService,
    public service: UsersService,
  ) {}

  ngOnInit() {
    this.serviceListBank.getListBank().subscribe(
      (resp) => {
        this.listBanks = resp.data;
      },
      (error) => {
        console.log(error, 'Error mostrando bancos');
      },
    );
  }

  createUser() {
    this.userForm.markAllAsTouched();
    this.showLoading();

    if (
      this.userForm.controls['userType'].value == 0 ||
      this.userForm.controls['userType'].value == 2
    ) {
      this.userForm.controls['funderStatus'].setValue(null);
    }

    if (
      this.userForm.controls['userType'].value != 1 &&
      this.userForm.controls['userType'].value != 2
    ) {
      this.userForm.controls['storeStatus'].setValue(false);
    }

    let bankId = +this.userForm.controls['bankId'].value;
    this.userForm.controls['bankId'].setValue(bankId);

    const formValue = this.userForm.value;
    formValue.name = this.formatToTitleCase(formValue.name);

    firstValueFrom(this.service.createUser(formValue)).then((resp: any) => {
      // Cerrar el loading
        Swal.close();
        this.userForm.reset();
        Swal.fire({
          icon: 'success',
          title: '¡Completado!',
          text: 'La petición se procesó correctamente',
        });
      },
    );
  }

  validacionInputReq(fieldName: string): boolean | null {
    return (
      this.userForm.controls[fieldName].errors &&
      this.userForm.controls[fieldName].touched
    );
  }

  showLoading() {
    Swal.fire({
      title: 'Solicitud de crédito.',
      html: 'Creando tu solicitud.<b></b>',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  private formatToTitleCase(value: string): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .split(' ')
      .filter((word) => word.length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
